import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Tooltip from '@material-ui/core/Tooltip';
import InvitedIcon from '@material-ui/icons/MailOutline';
import AcceptedIcon from '@material-ui/icons/DoneAll';
import WaitingIcon from '@material-ui/icons/HourglassEmpty';

const StatusChip = ({status}) => {

  const classes   = buildStyles();

  return (
    <Tooltip title={status || ""}>
      <Avatar className={clsx(classes[status], classes.chip)}>
        {ICONS[status]}
      </Avatar>
    </Tooltip>    
  );
}

export default StatusChip;

const buildStyles   = makeStyles(theme => ({
  chip      : {
    height      : theme.spacing(3),
    width       : theme.spacing(3),
    fontSize      : 14,
    fontWeight    : 300,
    "& svg"   : {
      // fontSize    : 12,
      height      : 14,
      width       : 14,
      color       : theme.palette.grey[700],
    }
  },
  waiting   : {
    backgroundColor        : `${theme.palette.grey[500]}55`, //`
  },
  invited   : {
    backgroundColor        : `${theme.palette.secondary.main}55`, //`
  },
  accepted  : {
    backgroundColor        : `${theme.palette.primary.main}55`, //`
  },
}));

const ICONS   = {
  waiting   : <WaitingIcon fontSize="small" />,
  invited   : <InvitedIcon fontSize="small" />,
  accepted  : <AcceptedIcon fontSize="small" />
};